import { CartoesDTO, CartoesJustificadosDTO } from "./IExtratoMensal";

function extrairListasDeferidos(justificados: CartoesJustificadosDTO) {
    return [
        ...(justificados.listaEsquecimento ?? []),
        ...(justificados.listaAbonoLegal ?? []),
        ...(justificados.listaAbonoAdministrativo ?? []),
        ...(justificados.listaDispensado ?? []),
        ...(justificados.listaFeriadoMunicipal ?? []),
        ...(justificados.listaFeriadoNacional ?? []),
        ...(justificados.listaFerias ?? []),
        ...(justificados.listaLicencaRemunerada ?? []),
        ...(justificados.listaLicencaNaoRemunerada ?? []),
        ...(justificados.listaRecesso ?? []),
        ...(justificados.listaDeferidoCoordenacao ?? []),
        ...(justificados.listaDeferidoAdministracao ?? []),
    ];
}

function extrairListasIndeferidos(justificados: CartoesJustificadosDTO) {
    return [
        ...(justificados.listaIndeferidoCoordenacao ?? []),
        ...(justificados.listaIndeferidoAdministracao ?? []),
        ...(justificados.listaAusencia ?? []),
        ...(justificados.listaCompensados ?? []),
    ];
}

export function processarCartoesJustificados(
    dadosExtrato: CartoesDTO | null
): CartoesDTO | null {
    const justificados = dadosExtrato?.cartoesJustificadosDTO;
    if (!justificados) return dadosExtrato;

    const listas = {
        listaDeferidos: extrairListasDeferidos(justificados),
        listaIndeferidos: extrairListasIndeferidos(justificados),
    };

    return {
        ...dadosExtrato,
        cartoesJustificadosDTO: {
            ...justificados,
            ...listas,
        },
    };
}

export function processarCartoesEspeciais(
    dadosExtrato: CartoesDTO | null
): CartoesDTO | null {
    const cartoesEspeciais = dadosExtrato?.cartoesEspeciaisDTO;
    if (!cartoesEspeciais) return dadosExtrato;

    const listas = {
        listaAntecipacao: cartoesEspeciais.antecipacao,
        listaReposicao: cartoesEspeciais.reposicao,
        listaSubstituicao: cartoesEspeciais.substituicao,
    };

    return {
        ...dadosExtrato,
        cartoesEspeciaisDTO: {
            ...cartoesEspeciais,
            ...listas,
        },
    };
}
